import CrashDetectionMonitor from './CrashDetectionMonitor'

export default CrashDetectionMonitor
